import { Trans } from 'react-i18next'

import { BuilderMenu, DefaultVariableResult, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Field, SingleIconSelect } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { BADGE_METADATA_COL_TYPES } from '@/shared/builder-constants'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { VariableSelectV2 } from '@/components/VariableSelectV2/VariableSelectV2'

import { ReactComponent as BadgeDot24 } from '@/assets/badge-dot24.svg?react'
import { ReactComponent as BadgeText24 } from '@/assets/badge-text24.svg?react'

/**
 * MenuItemBadgeAccordion is a function component that provides an interface for editing the badge settings of a menu item in a builder.

 */
function MenuItemBadgeAccordion({
  menu,
  menuIdx,
  menuItemIdx,
}: {
  menuIdx: number
  menu: BuilderMenu
  menuItemIdx: number
}) {
  const { updateMenu } = useAppBuilderContext()

  // The menu item badge settings editing interface
  return (
    <AccordionItem itemId={'menu-item-badge'} title={<Trans>Badge Settings</Trans>}>
      <Field>
        <label>
          <Trans>Badge Size</Trans>
        </label>
        <SingleIconSelect
          noTip
          onClick={async (opt) => {
            await updateMenu(menuIdx, (prev) => {
              prev.items[menuItemIdx].badgeSize = opt.id === 's' ? 's' : 'm'
            })
          }}
          options={[
            {
              id: 's',
              icon: () => <BadgeDot24 />,
              title: 'Without Counter',
            },
            {
              id: 'm',
              icon: () => <BadgeText24 />,
              title: 'With Counter',
            },
          ]}
          selected={menu.items[menuItemIdx].badgeSize || 's'}
        />
      </Field>
      <Field isVertical>
        <label>
          <Trans>Badge Metadata</Trans>
        </label>
        <VariableSelectV2
          id={`menu-item-${menuItemIdx}-badge-metadata`}
          value={menu.items[menuItemIdx].badgeMetadata}
          featureFlags={
            VariableSelectFeatureFlag.ColumnData |
            VariableSelectFeatureFlag.SingleCell |
            VariableSelectFeatureFlag.ProfileData |
            VariableSelectFeatureFlag.CustomText
          }
          forceUserSpecific
          variableColumnOptions={{
            columnTypes: BADGE_METADATA_COL_TYPES,
            excludeColIds: [],
          }}
          onChange={async (opt) => {
            await updateMenu(menuIdx, (prev) => {
              prev.items[menuItemIdx].badgeMetadata = opt as DefaultVariableResult
            })
          }}
        />
      </Field>
    </AccordionItem>
  )
}

export default MenuItemBadgeAccordion
